import { render, staticRenderFns } from "./SectionFields.vue?vue&type=template&id=3533b5c4"
import script from "./SectionFields.vue?vue&type=script&lang=js"
export * from "./SectionFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports